import React, { Dispatch } from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { ChooseCustomerField } from "@src/features/admin/components/Fields/ChooseCustomerField";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";

interface ChooseCustomerProps {
  index: number;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const ChooseCustomer = ({
  index,
  payload,
  dispatchPayload,
}: ChooseCustomerProps) => {
  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography>Choose Existing Customer</IgTypography>
      </Grid>
      <Grid item>
        <ChooseCustomerField
          payload={payload}
          onChange={(value) => dispatchPayload({ type: "setCustomer", value })}
        />
      </Grid>
      <Grid item textAlign={"end"}>
        <IgButton
          disabled={!payload.customer}
          onClick={() =>
            dispatchPayload({ type: "setTabIndex", value: index + 1 })
          }
        >
          Continue
        </IgButton>
      </Grid>
    </Grid>
  );
};
